<h1 mat-dialog-title>{{ 'packagingUnit.packagingUnit' | transloco }}</h1>

<mat-dialog-content>
  <app-packaging-units-overview #packagingUnitsTable [dataSource]="dataSource" [displayedColumns]="displayedColumns"
    [isUserValidator]="false">
  </app-packaging-units-overview>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="importPackagingUnits()" mat-raised-button type="submit" color="primary"
    [disabled]="packagingUnitsTable.selectedPackagingUnitIds.length === 0">
    {{ 'common.buttons.import' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
